define('services/ContractService',['require','lib/backbone/Backbone.Mixins.Transport.API','jquery','underscore'],function(require) {
  var API = require('lib/backbone/Backbone.Mixins.Transport.API');
  var $ = require('jquery');
  var _ = require('underscore');

  return {

    getPricableOrgs: function() {
      return API.request('get', '/contract/org');
    },

    getContractForUser: function(orgId, attributes) {
      return API.request('get', '/contract/org/{0}/user'.format(orgId), attributes, { ignoreHTTPErrors: true });
    },

    // see: https://hoist.podio.com/api/item/2162751
    getContracts: function() {
      return API.request('GET', '/contract/');
    },

    getContract: function(contractId) {
      return API.request('get', '/contract/{0}'.format(contractId));
    },

    calculatePrice: function(contractId, attributes) {
      return API.request('post', '/contract/{0}/price'.format(contractId), attributes);
    },

    updateContract: function(contractId, attributes) {
      return API.request('put', '/contract/{0}'.format(contractId), attributes);
    },

    changeToFixed: function(contractId, attributes) {
      return API.request('post', '/contract/{0}/change_to/fixed'.format(contractId), attributes);
    },

    changeToVariable: function(contractId) {
      return API.request('post', '/contract/{0}/change_to/variable'.format(contractId));
    },

    // see: https://hoist.podio.com/api/item/25997058
    getSalesAgent: function() {
      return API.request('GET', '/user/sales_agent');
    },

    findSalesAgent: function(salesAgentId) {
      return API.request('get', '/contact/user/{0}'.format(salesAgentId));
    },

    findAvailableSpaces: function(orgId) {
      var dfd = new $.Deferred();

      API.request('get', '/org/{0}/space'.format(orgId)).done(function(spaces) {
        dfd.resolve(_.reject(spaces, function(space) {
          return space.type === 'emp_network' || space.type === 'demo' || !space.name;
        }));
      });

      return dfd;
    }
  };
});

